// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2vDxY","rootSmall":"AddTileButton_rootSmall__2IG1X"};